import { render } from "./CustomersFilterValue.vue?vue&type=template&id=4ea450a4&scoped=true"
import script from "./CustomersFilterValue.vue?vue&type=script&lang=js"
export * from "./CustomersFilterValue.vue?vue&type=script&lang=js"

import "./CustomersFilterValue.vue?vue&type=style&index=0&id=4ea450a4&lang=scss&scoped=true"
import "./CustomersFilterValue.vue?vue&type=style&index=1&id=4ea450a4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea450a4"]])

export default __exports__